<template>
    <path d="M5.132 6.863c-.03-.03-.055-.065-.077-.103-.022-.04-.037-.08-.044-.12-.003-.043-.01-.09-.01-.145 0-.146.047-.265.135-.357.088-.092.202-.138.34-.138H15.53c.14 0 .252.046.34.138.09.092.132.21.132.357 0 .146-.043.267-.13.362-.09.096-.203.144-.34.144H5.47c-.14 0-.253-.042-.34-.134zm10.395 3.142c.14 0 .253.046.34.138.09.092.133.21.133.357 0 .146-.044.265-.132.357-.088.092-.202.138-.34.138H5.472c-.14 0-.253-.046-.34-.138-.016-.016-.03-.035-.045-.058l-.038-.07-.03-.07c-.008-.025-.014-.05-.017-.077 0-.023-.003-.053-.003-.083 0-.146.044-.265.132-.357.088-.092.202-.138.34-.138h10.055zm.34 4.132c.09.092.133.21.133.357 0 .145-.044.266-.132.362-.088.096-.202.144-.34.144H5.472c-.14 0-.253-.046-.34-.138-.016-.015-.028-.033-.04-.052-.01-.02-.02-.038-.032-.057-.01-.02-.02-.04-.027-.058l-.022-.063c-.003-.023-.01-.044-.01-.064v-.074c0-.146.047-.265.135-.357.088-.092.202-.138.34-.138H15.53c.13 0 .244.042.34.134z"/>
</template>

<script>
export default {
    name: 'tableIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 20 20');
    }
}
</script>
